import { EnvelopeIcon, PhoneIcon } from '@heroicons/react/20/solid'
import * as React from "react";
import Identicon from "react-identicons";

export default function UserGrid({users,organization}) {
    return (
        <ul role="list" className="grid grid-cols-1 gap-6 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 ">
            {users.map((user) => (
                <a href={`/dashboard/users/${user._id}?branch=${user.branch_info._id}&organization=${organization._id}`}
                    key={user.email}
                    className="col-span-1 flex flex-col divide-y divide-gray-200 rounded-lg bg-white text-center shadow"
                >
                    <div className="flex flex-1 flex-col p-8">
                        <Identicon
                            bg={"white"}
                            size="40"
                            className="mx-auto h-20 w-20 flex-shrink-0 rounded-full"
                            string={user._id}
                        />
                        <h3 className="mt-6 text-sm font-medium text-gray-900">{user.firstName} {user.lastName}</h3>
                        <dl className="mt-1 flex flex-grow flex-col justify-between">
                            <dt className="sr-only">Title</dt>
                            <dd className="text-sm text-gray-500">{user.branch_info.title}</dd>
                            <dd className="">
                <span className="inline-flex items-center rounded-full bg-green-50 px-2 py-1 text-xs font-medium text-green-700 ring-1 ring-inset ring-green-600/20">
                  {user.roles}
                </span>
                            </dd>
                        </dl>
                    </div>
                    <div>
                        <div className="-mt-px flex divide-x divide-gray-200">
                            <div className="flex w-0 flex-1">
                                <a
                                    href={`mailto:${user.email}`}
                                    className="relative -mr-px inline-flex w-0 flex-1 items-center justify-center gap-x-3 rounded-bl-lg border border-transparent py-4 text-sm font-semibold text-gray-900"
                                >
                                    <EnvelopeIcon aria-hidden="true" className="h-5 w-5 text-gray-400" />
                                    Email
                                </a>
                            </div>
                            <div className="-ml-px flex w-0 flex-1">
                                <a
                                    href={`tel:${user?.telephone}`}
                                    className="relative inline-flex w-0 flex-1 items-center justify-center gap-x-3 rounded-br-lg border border-transparent py-4 text-sm font-semibold text-gray-900"
                                >
                                    <PhoneIcon aria-hidden="true" className="h-5 w-5 text-gray-400" />
                                    Call
                                </a>
                            </div>
                        </div>
                    </div>
                </a>
            ))}
        </ul>
    )
}
